import type React from 'react';
import { inject } from 'mobx-react';

// mobx-react's inject returns the component unchanged, so a required store prop stays required at
// every call site. This drops the injected names from the exported signature.
export function injectStores<K extends string>(...stores: K[]) {
  return <P extends Record<K, unknown>>(component: React.ComponentType<P>) =>
    inject(...stores)(component) as unknown as React.ComponentType<Omit<P, K>>;
}
